import Interceptor from "@/plugins/interceptor";
import persistentData from '@/plugins/persistentData';

const urlAPI = `${process.env.VUE_APP_URL_API}/person`;

const authenticate = {
  state: {
    logged_in: false
  },
  actions: {
    logIn(_, guid) {
      return new Promise((resolve, reject) => {
        Interceptor.authenticate.post(`${urlAPI}/authenticate?personToken=${guid}`)
          .then(res => {
            persistentData.setData('jwtToken', res.data.Token, false);
            resolve(res);
          })
          .catch(err => {
            // if (err.response && err.response.status === 401) {}
            reject(err);
          });
      });
    },
    loggedIn({ commit }, value) {
      commit('SET_LOGGED_IN', value);
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.logged_in = value;
    }
  }
};

export default authenticate;
